import { render, staticRenderFns } from "./BFormInputDateBetween.vue?vue&type=template&id=36e48f30&scoped=true"
import script from "./BFormInputDateBetween.vue?vue&type=script&lang=js"
export * from "./BFormInputDateBetween.vue?vue&type=script&lang=js"
import style0 from "./BFormInputDateBetween.vue?vue&type=style&index=0&id=36e48f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e48f30",
  null
  
)

export default component.exports